// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-delete[data-v-6c1787f8] {\nspan {\n    margin-left: 4px;\n}\n}\n.customer-category_empty[data-v-6c1787f8] {\n  height: calc(100vh - 130px);\n}\n\n", ""]);
// Exports
module.exports = exports;
